export default __webpack_public_path__ + "static/media/logo_realtor-equal-housing.032b9271.svg";